import styled, { css } from "styled-components";
import { color } from "styled-system";

const Label = styled.label`
  font-weight: bold;
  margin-bottom: 0.35rem;
  ${color};

  ${({ required }) =>
    required &&
    css`
      ::after {
        content: "*";
        padding-left: 2px;
        color: ${({ theme }) => theme.danger};
      }
    `};
`;

export default Label;
